import { h, Component } from "preact";
import { connect } from "preact-redux";
import PoweredByJibber from "/chat/src/components/PoweredByJibber";
import GDPRStyle from "./GDPROverlay.scss";
import style from "./style.scss";
import {
  UserModel,
  CustomizationModel,
  FeaturesModel,
} from "/chat/src/redux/model";
import Button from "./Button";
import CheckboxInput from "/chat/src/components/Forms/CheckboxInput";

class GDPROverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      GDPRCheckBox: false,
    };
  }
  render() {
    if (this.props.gdprRequire && !this.props.acceptedGDPR) {
      const GDPRPromptText = this.props.language.get("GDPRPrompt");
      return (
        <div className={style.Body}>
          <div className={GDPRStyle.GDPRPromptText}>
            <CheckboxInput
              value={this.state.GDPRCheckBox}
              onChange={(value) => this.setState({ GDPRCheckBox: value })}
              label={GDPRPromptText}
            />
          </div>
          <Button disabled={!this.state.GDPRCheckBox} />
          <PoweredByJibber />
        </div>
      );
    }

    return this.props.children[0];
  }
}

function mapStateToProps(state) {
  const acceptedGDPR = UserModel.getAcceptedGDPR(state);
  const language = CustomizationModel.getLanguage(state);
  const gdprRequire = FeaturesModel.getGdprRequire(state);

  const user = UserModel.get(state);
  return { acceptedGDPR, user, language, gdprRequire };
}

export default connect(mapStateToProps)(GDPROverlay);



// WEBPACK FOOTER //
// ./routes/GDPROverlay/GDPROverlay.js